import { render, staticRenderFns } from "./dytTextarea.vue?vue&type=template&id=38711f54&"
import script from "./dytTextarea.vue?vue&type=script&lang=js&"
export * from "./dytTextarea.vue?vue&type=script&lang=js&"
import style0 from "./dytTextarea.vue?vue&type=style&index=0&id=38711f54&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports